import { FC } from 'react';

import { SPALink } from '@hh.ru/redux-spa-middleware';
import BlokoLink from 'bloko/blocks/link';
import Text, { TextImportance } from 'bloko/blocks/text';
import numberFormatter from 'bloko/common/numberFormatter';

import { Catalog } from 'src/models/searchCatalogList';
import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

import styles from './catalog-links.less';

interface CatalogLinkProps {
    catalog: Catalog;
}

const CatalogLink: FC<CatalogLinkProps> = ({ catalog }) => {
    return (
        <div className={styles.catalogLink}>
            <BlokoLink Element={SPALink} to={`/${catalog.catalogPath}`} isSeoLink>
                {catalog.nominative}
            </BlokoLink>
            {catalog.count > 0 && (
                <>
                    {NON_BREAKING_SPACE}
                    <Text Element="span" italic importance={TextImportance.Tertiary}>
                        {numberFormatter.format(String(catalog.count), {
                            groupSeparator: NON_BREAKING_SPACE,
                        })}
                    </Text>
                </>
            )}
        </div>
    );
};

export default CatalogLink;
